import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppEffects } from './app-effects';
import { initialAppState } from './app-state';
import { SessionStateModule } from '../session/session-state.module';
import { RouterStateModule } from '../router/router-state.module';
import { AuthStateModule } from '../auth/auth-state.module';
import { ToastStateModule } from '../toast/toast-state.module';
import { PreferenceStateModule } from '../preference/preference-state.module';
import { EntityStateModule } from '../shared/entities/entities-state.module';
import { metaReducers } from './app-meta-reducer';
import { GlobalStateModule } from '../global/global-state.module';
import { BillingStateModule } from '../billing/billing-state.module';
import { combineReducers } from '@core/utils/state';
import { IntercomStateModule } from '../intercom/intercom-state.module';
import { LocationStateModule } from '../locations/locations-state.module';
import { CoreModule } from '@core/core.module';
import { GoEffects } from '../go/go.effects';
import { WorkplacesStateModule } from '../workplaces/workplaces-state.module';
import { SettingsStateModule } from '../settings/settings-state.module';
import { EmployeesStateModule } from '../employees/employees-state.module';

@NgModule({
  imports: [
    EffectsModule.forRoot([
      AppEffects,
      GoEffects
    ]),
    StoreModule.forRoot({}, {
      initialState: initialAppState,
      metaReducers: metaReducers,
      reducerFactory: combineReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
        strictStateSerializability: false,
        strictActionSerializability: false
      }
    }),
    CoreModule,
    BillingStateModule,
    RouterStateModule,
    SessionStateModule,
    AuthStateModule,
    ToastStateModule,
    PreferenceStateModule,
    EntityStateModule,
    GlobalStateModule,
    IntercomStateModule,
    LocationStateModule,
    WorkplacesStateModule,
    SettingsStateModule,
    EmployeesStateModule
  ],
  declarations: []
})
export class AppStateModule {
}
